<template>
    <div class="py-4 container-fluid">        
        <div class="row">
            <div>
                {{ $t('common.Inspector_dashboard') }}                
            </div>
            <div class="col-lg-9">
                <div class="row">
                    <div class="col-lg-10">
                        <div style="width: 50%; float: left; ">
                            <input v-model="searchText" type="text" class="form-control"
                                style="border:1px solid #d2d6da; padding: .375rem .75rem;" :placeholder="$t('common.Search') + '...'" @keydown="searchBoxKeyDown">
                        </div>
                        <div style="float:left; margin-left:10px;">
                            <button v-on:click="searchUserActions" class="btn bg-gradient-success">{{ $t('common.Search') }}</button>
                        </div>
                    </div>
                </div>
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-8">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('dashboard.User_actions') }} <span class="dashboardNoOfRecords">({{ $t('dashboard.No_of_user_actions_found') }} {{ userActions.length }})</span>
                            </h6>
                        </div>
                        <div class="col-lg-4">                            
                        </div>
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container" :style="[userActions.length > 3 ? 'height: 300px' : '']">
                            <table class="table align-items-center">
                                <thead>
                                    <tr>
                                        <td>&nbsp;</td>                                        
                                        <td>
                                            <div class="text-left">
                                                <p class="mb-0 text-xs font-weight-bold">{{ $t('dashboard.Date_time') }}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-left">
                                                <p class="mb-0 text-xs font-weight-bold">{{ $t('dashboard.User_agent_host') }}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-left">
                                                <p class="mb-0 text-xs font-weight-bold">{{ $t('dashboard.User_actions') }}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-left">
                                                <p class="mb-0 text-xs font-weight-bold">{{ $t('dashboard.User_name_role') }}</p>
                                            </div>
                                        </td>                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="userAction in userActions" v-bind:key="userAction.id"> 
                                        <td>
                                            <i class="fas fa-desktop text-lg opacity-6" v-if="userAction.deviceType === 'Desktop'"></i>
                                            <i class="fas fa-mobile text-lg opacity-6" v-else></i>
                                        </td>                                           
                                        <td>
                                            <div class="text-left">
                                                <h6 class="mb-0 text-sm font-weight-normal">                                                    
                                                    {{ formatDate(userAction.dateTimeStamp) }}
                                                </h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-left">
                                                <h6 class="mb-0 text-sm font-weight-normal">                                                    
                                                    {{ userAction.userAgent }} <br> 
                                                    {{ userAction.userHostIp }}
                                                </h6>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-left">
                                                <h6 class="mb-0 text-sm font-weight-normal">
                                                    {{ userAction.userAction1 }}
                                                </h6>
                                            </div>
                                        </td>
                                        <td style="white-space: nowrap !important;">
                                            <div class="text-left col">
                                                <h6 class="mb-0 text-sm font-weight-normal">
                                                    {{ userAction.userName }} <br>
                                                    {{ userAction.userRole }}
                                                </h6>
                                            </div>
                                        </td>                                        
                                    </tr>
                                </tbody>
                            </table>                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">                
                <div class="card mb-4">
                    <h6 class="ms-3 mt-3 mb-2">{{ $t('dashboard.Login_log') }}</h6>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <ul class="dashboard-log list-unstyled row">
                            <li class="col-md-12 text-sm">
                                {{ $t('dashboard.Last_login') }}:
                                <span style="color: #337ab7;">
                                    {{ formatDate(userLoginLog.dateTimeStamp) }}
                                </span>
                            </li>
                        </ul>
                        <p class="text-danger small" v-if="!userLoginLog.id">{{ $t('dashboard.No_activity_logged') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Dashboard_page',
    components: {        
    },
    data() {
        return {
            searchText: '',   
            userActions: [],
            loginlogs: [],
            gets: [],            
            userLoginLog: []
        }
    },
    computed: {   
        userRoleName() {
            return this.$store.state.user?.roleName;
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);
            const response = await axios.get("Dashboard/getallkeeper/");
            this.gets = response.data;

            if (this.gets.success) {                
                this.userLoginLog = this.gets.data['lastUserLoginLog'];
                this.userActions = this.gets.data['lstUserLoginLog'];
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        this.$store.commit('setShowLoading', false);
    },
    methods: {
        searchBoxKeyDown() {
            //console.log('Key pressed:', event.key);
        },
        formatDate(dateTimeStamp) {
            return new Date(dateTimeStamp).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        }, 
        async searchUserActions() {
            try {
                this.$store.commit('setShowLoading', true);
                if (this.searchText != '') {
                    const response = await axios.get("Dashboard/getallkeeperbysearch?search=" + this.searchText);
                    this.gets = response.data;
                } else {
                    this.$showError('errors.Search_text_is_not_specified');                        
                }

                if (this.gets.success) {  
                    this.userLoginLog = this.gets.data['lastUserLoginLog'];
                    this.userActions = this.gets.data['lstUserLoginLog'];
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
            this.$store.commit('setShowLoading', false);
        },                
    }
}
</script>

<style scoped>
.table td,
.table th {
    white-space: normal !important;
}
</style>

<style scoped>
    .table-container {
        width: 100%;
        margin: 0 auto;
        position: relative;
        /* height: 300px; */
        overflow: auto;
    }

    /* Style table */
    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 1em;
    }

    thead {
        position: sticky;
        top: 0;
        background-color: #fff;
    }

    thead td {
        background-color: #fff;         
        /* padding: 1rem 0.5rem;       */  
        border-bottom: 2px solid #ddd;
    }

    .well-header3 {
        font-size: 22px;
        margin: 0 0 0 -8px;
        padding-left: 10px;
        border-left: 10px solid;
        border-color: #586ca5;
    }

    .dashboardNoOfRecords {
        font-size: 12px;
    }
    .dashboardNoOfRecords {
        font-size: 12px;
        font-weight: normal;
    }
</style>